export default class Rate {
	constructor({ id, event, name, price, category } = {}) {
		this.id = id;
		this.event = event;
		this.name = name;
		this.price = price;
		this.category = category;
	}

	static buildFromJSON(json) {
		return new Rate({
			id: json.id,
			event: json.event,
			name: json.name,
			price: json.price,
			category: json.category
		});
	}

	toJSON() {
		return {
			id: this.id,
			event: this.event,
			name: this.name,
			price: this.price,
			category: this.category
		};
	}

	getId() {
		return this.id;
	}

	getEvent() {
		return this.event;
	}

	getName() {
		return this.name;
	}

	getPrice() {
		return this.price;
	}

	getCategory() {
		return this.category;
	}
}
